import React, { CSSProperties } from 'react'

import CopyLink from '@/components/misc/PanelInviteEmailTemplate/CopyLink'
import { useCompanyCompassLink } from '@/hooks/useCompanyCompassLink'
import { useIsVerySmallDevice } from '@/hooks/useIsVerySmallDevice'
import usePosthogCapture from '@/hooks/usePosthogCapture/usePosthogCapture'

interface Props {
  className?: string
  style?: CSSProperties
}

const CompanyCompassCopyLinkButton: React.FC<Props> = ({
  className,
  style,
}) => {
  const isVerySmallDevice = useIsVerySmallDevice()
  const link = useCompanyCompassLink()
  const { posthogCapture } = usePosthogCapture()

  return (
    <CopyLink
      className={className}
      textToCopy={link}
      buttonText={isVerySmallDevice ? 'Copy' : 'Copy link'}
      style={{ minWidth: isVerySmallDevice ? '90px' : '110px', ...style }}
      onClick={() =>
        posthogCapture({
          appArea: 'compass',
          action: 'global-link-copied',
        })
      }
    />
  )
}

export default CompanyCompassCopyLinkButton
